module.exports = __webpack_public_path__ + "static/media/bg-0.40d56f4a.jpg";